import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function PrivacyPolicy() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
            <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="privacy-container faq  terms-nd-condition" style={{ padding: '60px 0', minHeight: '70vh' }}>
  <div className={`container ${styles.container}`}>
        <header className="privacy-header">
          <h1 className='main-heading text-left'>Resumate Privacy Policy</h1>
          <p>Last updated: October 1st, 2025</p>
        </header>
        <section className="privacy-content">
          <p>
            Welcome to Resumate. Your privacy matters to us. This Privacy Policy explains how we
            collect, use, share, and protect your personal information when you use our mobile
            application (the “App”).
          </p>
          <p>
            By creating an account and using Resumate, you agree to the practices described in this
            Policy. If you do not agree, please do not use our App.
          </p>
        </section>
        <article>
         <h2 className='inner-heading text-left'>1. Information We Collect</h2>

          <h3 className='child-inner'>a. Registration Information</h3>
          <ul className='terms-list'>
            <li>Name</li>
            <li>Email address</li>
            <li>Date of birth (must be 18+)</li>
            <li>Gender and preferences</li>
            <li>Photos you choose to upload</li>
            <li>Location</li>
            <li>Mobile number</li>
            <li>Sexual orientation</li>
            <li>Marital status</li>
            <li>Ethnic background</li>
            <li>Height</li>
            <li>Religion or belief system</li>
            <li>Education history</li>
            <li>Dietary preferences</li>
            <li>Smoking habits</li>
            <li>Drinking habits</li>
            <li>Exercise level</li>
            <li>Kids status</li>
          </ul>

           <h3 className='child-inner'>b. Profile Information (Your “Resume”)</h3>
          <ul className='terms-list'>
            <li>Answers to open-ended questions about your values, goals, and relationships</li>
            <li>AI-generated profile summaries created from your inputs</li>
            <li>Optional details you choose to include</li>
          </ul>

           <h3 className='child-inner'>c. Matching & Interaction Data</h3>
          <ul className='terms-list'>
            <li>Resume submissions to other users</li>
            <li>Whether submissions are accepted or declined</li>
            <li>Video call activity (date, time, duration)</li>
            <li>Feedback provided after calls</li>
            <li>Messages exchanged once mutual approval is granted</li>
          </ul>

           <h3 className='child-inner'>d. Device & Technical Information</h3>
          <ul className='terms-list'>
            <li>Device type and operating system</li>
            <li>Log data (IP address, app usage, error reports)</li>
            <li>Optional location information (if enabled)</li>
          </ul>

           <h3 className='child-inner'>e. Payment Information</h3>
          <ul className='terms-list'>
            <li>Payment details are processed by third-party providers (App Store, Google Play).</li>
            <li>Resumate does not store your card details.</li>
          </ul>
        </article>

        <article>
         <h2 className='inner-heading text-left'>2. How We Use Your Information</h2>
          <ul className='terms-list'>
            <li>Provide and improve the App and its features</li>
            <li>Generate your AI-powered profile summary</li>
            <li>Match you with compatible users</li>
            <li>Facilitate resume submissions and approvals</li>
            <li>Enable secure video calls and private chat</li>
            <li>Ensure safety, detect fraud, and enforce our Terms of Use</li>
            <li>Communicate updates, security notices, and support responses</li>
            <li>Offer optional premium features</li>
          </ul>
        </article>

        <article>
         <h2 className='inner-heading text-left'>3. Sharing of Information</h2>
          <ul className='terms-list'>
            <li>
              <strong>With Other Users:</strong> Profile and resume details you choose to provide
              are visible to others. Private details (e.g., email, phone number) are never shared.
            </li>
            <li>
              <strong>Service Providers:</strong> Trusted third parties may handle hosting,
              payments, analytics, or video calls.
            </li>
            <li>
              <strong>Legal & Safety Reasons:</strong> Information may be disclosed if required by
              law or to protect rights, safety, or security.
            </li>
            <li>
              <strong>Business Changes:</strong> If Resumate is acquired, merged, or reorganized,
              data may transfer as part of that process.
            </li>
          </ul>
          <p>We do not sell your personal data to advertisers or third parties.</p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>4. Cookies & Tracking Technologies</h2>
          <p>
            If you use our landing page or enable certain features, we may collect data through
            cookies, beacons, or similar technologies to:
          </p>
          <ul className='terms-list'>
            <li>Improve functionality and performance</li>
            <li>Analyze usage patterns</li>
            <li>Enable push notifications</li>
          </ul>
          <p>
            You can manage or disable cookies through your device or browser settings, though some
            features may not work as intended.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>5. Your Choices and Rights</h2>
          <ul className='terms-list'>
            <li>Accessing a copy of your data</li>
            <li>Updating or correcting information</li>
            <li>Deleting your account and data</li>
            <li>Restricting or objecting to certain data uses</li>
            <li>Withdrawing consent for optional features</li>
          </ul>

           <h3 className='child-inner'>GDPR Users (EU/UK)</h3>
          <ul className='terms-list'>
            <li>
              Legal bases for processing include: consent, contract performance, compliance with
              legal obligations, and legitimate interests.
            </li>
            <li>You may request data portability or lodge a complaint with your local authority.</li>
          </ul>

           <h3 className='child-inner'>CCPA Users (California)</h3>
          <ul className='terms-list'>
            <li>
              You have the right to request access, deletion, and disclosure of data collected in
              the past 12 months.
            </li>
            <li>We do not sell your personal information.</li>
          </ul>
          <p>
            You can exercise rights via account settings or by contacting us at{" "}
            <a className='email' href="mailto:info@resumate.org">info@resumate.org</a>.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>6. Data Retention</h2>
          <ul className='terms-list'>
            <li>If you delete your account, your profile will no longer be visible.</li>
            <li>Certain data may be retained for legal, safety, or fraud-prevention purposes.</li>
            <li>Messages and resumes are deleted with accounts, except as required by law.</li>
          </ul>
        </article>

        <article>
         <h2 className='inner-heading text-left'>7. Security</h2>
          <p>
            We use industry-standard measures, including encryption and secure servers. However, no
            system is 100% secure, and we cannot guarantee absolute protection.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>8. Data Breach Notification</h2>
          <p>
            If a data breach occurs, we will notify affected users and regulators as required by
            applicable law.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>9. Age Restriction</h2>
          <p>
            Resumate is for individuals 18 years and older. We do not knowingly collect information
            from anyone under 18. If discovered, such data will be deleted.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>10. International Users</h2>
          <p>
            Your information may be processed and stored outside your home country. We take steps to
            ensure adequate protection under applicable laws.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. If changes are significant, we will
            notify you in-app or by email.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>12. Governing Law & Dispute Resolution</h2>
          <p>
            This Policy is governed by the laws of the State of Arizona, USA. Any disputes shall
            first be attempted through informal resolution. If unresolved, disputes may be subject
            to arbitration or courts located in Maricopa County, Arizona, unless prohibited by law.
          </p>
        </article>

        <article>
         <h2 className='inner-heading text-left'>13. Contact Us</h2>
          <address>
            Sparkle from Within LLC<br />
            4539 N 22nd St, Ste N, Phoenix, AZ 85016<br />
            <a className='email'  href="mailto:info@resumate.org">info@resumate.org</a>
          </address>
        </article>
</div>
      </main>

      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
